import { Box, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { GRAY_COLORS } from 'asterX-UI'
import { colorStatusesByCode } from 'constants/deals'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import ActivityFeed from 'components/Desktop/WorkListView/ActivityFeed'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 8,
    display: 'flex',
    justifyContent: 'space-between',
    padding: 4,
    gap: 8
  },
  idWl: {
    color: GRAY_COLORS[800],
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    fontFamily: 'Inter'
  },
  statuses: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    alignItems: 'end',
    cursor: 'pointer'
  }
}))

const Header = ({ wlId, status, carfinStatus, globalId }) => {
  const classes = useStyles()
  const [openFeed, setOpenFeed] = useState(false)

  return (
    <div className={classes.root}>
      <div className={classes.idWl}>{`РЛ ${
        globalId ? `${globalId}` : ''
      }`}</div>

      <Box className={classes.statuses}>
        <ChipStandard
          {...colorStatusesByCode(status?.code)}
          onClick={() => setOpenFeed(true)}
        >
          {status?.name}
        </ChipStandard>

        {carfinStatus?.name && (
          <ChipStandard
            {...{
              color: 'rgb(65, 111, 198)',
              backgroundColor: 'rgb(245, 246, 255)'
            }}
            onClick={() => setOpenFeed(true)}
          >
            ФС: {carfinStatus?.name}
          </ChipStandard>
        )}
      </Box>

      <ActivityFeed
        id={wlId}
        open={openFeed}
        onClose={() => setOpenFeed(false)}
      />
    </div>
  )
}

export default Header
